var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/hamburger"),React.createElement("g",{"id":"icon/hamburger","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M0,26.3333333 L32,26.3333333 L32,22.7777778 L0,22.7777778 L0,26.3333333 Z M0,17.4444444 L32,17.4444444 L32,13.8888889 L0,13.8888889 L0,17.4444444 Z M0,5 L0,8.55555556 L32,8.55555556 L32,5 L0,5 Z","id":"Shape","fill":"currentColor","fillRule":"nonzero"}))]);
}

Hamburger.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
